<template>
    <div class="clearfix main_center">
        <div class="wrap" v-loading="loading">
            <step :showReview="false" :project-name="$route.query.bidSectionName" />
            <iframe id="bid_frame" :src="iframeUrl" frameborder="0"></iframe>
            <!-- <div class="expert-review-progress">
                <progressBar ref="progress" />
            </div> -->
            <el-dialog
                :visible.sync="dialogVisible"
                width="30%"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                title="提示"
                :before-close="handleClose">
                <div class="dialog-content">
                    <div class="dialog-content__msg">{{msg}}</div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleClose">确定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import step from '../traddingWitness/openBidWitness/components/step.vue'
import {tabsCloseCurrentHandle} from '@/utils/routeTab';

    export default {
        components: {
            step,
        },
        data() {
            return {
                iframeUrl: '',
                loading: true,
                msg: '',
                time: 5,
                dialogVisible: false,
            }
        },
        mounted() {
            this.getUrl()
            setTimeout(() => {
                // iframe 内容会有几次重定向会闪屏，所以做一个延迟
                this.loading = false
            }, 1500);
            this.getProgress()
            this.poll()
        },
        methods: {
            getUrl() {
                const token = this.$cookie.get('access_token')
                const params = {
                    token,
                    bidid: this.$route.query.tradePlatfBidSectionId,
                    tag: 'viewWorkFlow',
                    layout: 0,
                    tableHidden: this.$route.query.type === 1,
                    type: this.$route.query.type
                }
                this.iframeUrl = `${process.env.VUE_APP_bidUrl}/external/flow?${qs.stringify(params)}`
                // this.iframeUrl = `http://172.16.26.192:40087/external/flow?${qs.stringify(params)}`
            },
            handleClose() {
                this.dialogVisible = false
                this.resetState()
                tabsCloseCurrentHandle()
            },
            resetState() {
                clearInterval(this.timer)
                clearInterval(this.msgTimer)
                this.time = 5
            },
            generateMsg() {
                this.msg = `本项目授权查看时间已到,页面将在 5 s后清空数据。若需继续查看，请重新发授权申请!`
                this.msgTimer = setInterval(() => {
                    this.msg = `本项目授权查看时间已到,页面将在 ${--this.time} s后清空数据。若需继续查看，请重新发授权申请!`
                    if (this.time === 0) {
                        this.resetState()
                        tabsCloseCurrentHandle()
                    }
                }, 1000)
            },
            // 轮询是否时间超时
            poll() {
                this.timer = setInterval(() => {
                    this.getProgress()
                }, 1000 * 60)
            },
            getProgress() {
                this.$http.post(`/evaluationProcess/verdict`, {
                        id: this.$route.query.id,
                    }).then(res => {
                        if (res.data.data) {
                            this.dialogVisible = true
                            clearInterval(this.timer)
                            this.generateMsg()
                        }
                    })
            }
        }
    }
</script>

<style lang="less" scoped>
.main_center {
    .wrap {
        padding: 16px;
        background: #fff;
        position: relative;
    }
    iframe {
        min-height: 800px;
        width: 100%;
        height: 100%;
    }
}

.expert-review-progress {
    position: absolute;
    bottom: 50px;
    left: 45px;
    width: 256px;
}
</style>